import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

function RequestSentIcon(props) {
    return (
        <SvgIcon {...props} viewBox="0 0 36 32">
            <path id="Union_16" data-name="Union 16" d="M18509-5834.67l27.6-2.331-27.6-2.331V-5853l35.984,16h.016l-.01,0,.01,0h-.016L18509-5821Z" transform="translate(-18508.998 5853.001)" fill="#97d700" />
        </SvgIcon>
    );
}

export default RequestSentIcon;